'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var UserPanel;
(function (UserPanel) {
    var MyUserPanel = /** @class */ (function () {
        function MyUserPanel() {
            $(document).ready(function () {
                $('.trigUserPanel').click(function (e) {
                    e.preventDefault();
                    $('.bulletUserPanel').toggleClass('open');
                });
            });
        }
        return MyUserPanel;
    }());
    UserPanel.MyUserPanel = MyUserPanel;
})(UserPanel || (UserPanel = {}));
exports.default = UserPanel;
